module.exports = __webpack_public_path__ + "static/media/31JFA12.be99a4e4.jpg";